export default "__VITE_ASSET__BCWwhk99__"